"use client";
import { createContext } from 'react';

const LayoutGroupContext = createContext({});

export { LayoutGroupContext };
//# sourceMappingURL=LayoutGroupContext.mjs.map
